import React from 'react';

export interface ChartTooltipState {
  /** point position in the chart's viewBox coordinates */
  x: number;
  y: number;
  content: React.ReactNode;
}

interface Props {
  tooltip: ChartTooltipState | null;
  /** the chart's viewBox size, used to place the pop-out over the scaled svg */
  width: number;
  height: number;
}

/**
 * Pop-out for a hovered chart point. Render it inside a `position: relative` box that also holds the
 * svg; it is positioned in percentages so it follows the svg however it is scaled.
 */
export const ChartTooltip: React.FC<Props> = ({tooltip, width, height}) => {
  if(!tooltip)
    return null;
  let left = (tooltip.x / width) * 100;
  let top = (tooltip.y / height) * 100;
  // keep the pop-out on the chart: flip to the left of the point on the right half, below it near the top
  let flipX = left > 60;
  let flipY = top < 30;
  return (
    <div style={{
      position: 'absolute',
      left: `${left}%`,
      top: `${top}%`,
      transform: `translate(${flipX ? 'calc(-100% - 12px)' : '12px'}, ${flipY ? '12px' : 'calc(-100% - 12px)'})`,
      background: 'rgba(20,20,20,0.95)',
      border: '1px solid rgba(255,255,255,0.2)',
      borderRadius: 6,
      padding: '6px 10px',
      fontSize: '0.85em',
      color: '#e0e0e0',
      pointerEvents: 'none',
      whiteSpace: 'nowrap',
      zIndex: 10,
      boxShadow: '0 2px 8px rgba(0,0,0,0.5)',
    }}>
      {tooltip.content}
    </div>
  );
}

/** A larger invisible circle on top of a data point, so it's easy to hover. */
export const HoverTarget: React.FC<{cx: number, cy: number, onEnter: () => void, onLeave: () => void}> = ({cx, cy, onEnter, onLeave}) => (
  <circle cx={cx} cy={cy} r={10} fill="transparent" style={{cursor: 'pointer'}} onMouseEnter={onEnter} onMouseLeave={onLeave} />
);
